import axios from "axios";
import { eventBus } from "@/main";

const modulePayment = {
  namespaced: true,
  state: {
    ktbFastPayLoading: false,
    ktbFastPayError: null,
    paymentHistory: [],
    paymentHistoryTotal: 0,
    paymentHistoryLoading: false,
    transactionDetails: null,
    transactionDetailsLoading: false,
    transactionDetailsError: null,
  },
  getters: {
    getKtbFastPayLoading: state => state.ktbFastPayLoading,
    getKtbFastPayError: state => state.ktbFastPayError,
    getPaymentHistory: state => state.paymentHistory,
    getPaymentHistoryTotal: state => state.paymentHistoryTotal,
    getPaymentHistoryLoading: state => state.paymentHistoryLoading,
    getTransactionDetails: state => state.transactionDetails,
    getTransactionDetailsLoading: state => state.transactionDetailsLoading,
    getTransactionDetailsError: state => state.transactionDetailsError,
  },
  mutations: {
    SET_KTB_FAST_PAY_LOADING(state, loading) {
      state.ktbFastPayLoading = loading;
    },
    SET_KTB_FAST_PAY_ERROR(state, error) {
      state.ktbFastPayError = error;
    },
    SET_PAYMENT_HISTORY(state, payload) {
      if (payload && payload.orders) {
        state.paymentHistory = payload.orders;
        state.paymentHistoryTotal = payload.total || 0;
      } else {
        state.paymentHistory = payload || [];
        state.paymentHistoryTotal = (payload || []).length;
      }
    },
    SET_PAYMENT_HISTORY_LOADING(state, loading) {
      state.paymentHistoryLoading = loading;
    },
    SET_TRANSACTION_DETAILS(state, data) {
      state.transactionDetails = data;
    },
    SET_TRANSACTION_DETAILS_LOADING(state, loading) {
      state.transactionDetailsLoading = loading;
    },
    SET_TRANSACTION_DETAILS_ERROR(state, error) {
      state.transactionDetailsError = error;
    },
  },
  actions: {
    async processKtbFastPayPayment({ commit }, { clinicUrl, branchUrl, amount, successUrl, failUrl, cancelUrl }) {
      commit("SET_KTB_FAST_PAY_LOADING", true);
      commit("SET_KTB_FAST_PAY_ERROR", null);

      try {
        const apiUrl = `${axios.defaults.baseURL}/api/branch/${clinicUrl}/${branchUrl}/creditBalance`;

        const response = await axios.post(apiUrl, {
          amount: parseFloat(amount),
          successUrl,
          failUrl,
          cancelUrl
        });

        const { data } = response;
        if (!data.ktbFastPayPayload) {
          throw new Error("ไม่พบข้อมูลการทำรายการ KTB Fast Pay");
        }

        // Create and submit hidden form
        const formData = data.ktbFastPayPayload;
        const hiddenForm = document.createElement("form");
        hiddenForm.method = "POST";
        hiddenForm.action = "https://uatktbfastpay.ktb.co.th/SIT/eng/payment/payForm.jsp";

        Object.keys(formData).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = formData[key];
          hiddenForm.appendChild(input);
        });

        document.body.appendChild(hiddenForm);
        hiddenForm.submit();

        return data;
      } catch (error) {
        commit("SET_KTB_FAST_PAY_ERROR", error.message || "เกิดข้อผิดพลาดในการทำรายการ");
        throw error;
      } finally {
        commit("SET_KTB_FAST_PAY_LOADING", false);
      }
    },

    async fetchPaymentHistory({ commit }, { clinicUrl, branchUrl, sort, order, offset, limit }) {
      commit("SET_PAYMENT_HISTORY_LOADING", true);

      try {
        // Build query parameters
        const params = {};
        if (sort) params.sort = sort;
        if (order) params.order = order;
        if (offset !== undefined) params.offset = offset;
        if (limit !== undefined) params.limit = limit;

        const response = await axios.get(`/api/order/${clinicUrl}/${branchUrl}`, { params });

        // Check if the response is an object with a data property containing the actual orders
        // This handles the case where the API returns { data: [...], total: number }
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          commit("SET_PAYMENT_HISTORY", {
            orders: response.data.data,
            total: response.data.total || response.data.data.length
          });
          return {
            data: response.data.data,
            total: response.data.total || response.data.data.length
          };
        } else {
          // Handle the case where the API just returns an array directly
          commit("SET_PAYMENT_HISTORY", {
            orders: response.data,
            total: response.data.length
          });
          return {
            data: response.data,
            total: response.data.length
          };
        }
      } catch (error) {
        eventBus.$emit("apiError", error);
        throw error;
      } finally {
        commit("SET_PAYMENT_HISTORY_LOADING", false);
      }
    },

    async fetchTransactionDetails({ commit }, { clinicUrl, branchUrl, referenceId }) {
      commit("SET_TRANSACTION_DETAILS_LOADING", true);
      commit("SET_TRANSACTION_DETAILS_ERROR", null);
      commit("SET_TRANSACTION_DETAILS", null);

      try {
        if (!clinicUrl || !branchUrl || !referenceId) {
          throw new Error("ข้อมูลไม่ครบถ้วน ไม่สามารถดึงข้อมูลการทำรายการได้");
        }

        const response = await axios.get(`/api/ktb-fastpay/transaction/${clinicUrl}/${branchUrl}/${referenceId}`);

        if (response.data) {
          commit("SET_TRANSACTION_DETAILS", response.data);
          return response.data;
        } else {
          throw new Error("ไม่พบข้อมูลการทำรายการ");
        }
      } catch (error) {
        let errorMessage = "ไม่สามารถดึงข้อมูลการทำรายการได้";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        commit("SET_TRANSACTION_DETAILS_ERROR", errorMessage);
        throw error;
      } finally {
        commit("SET_TRANSACTION_DETAILS_LOADING", false);
      }
    }
  }
};

export default modulePayment;